export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  // Don't load tracker in development mode
  if (
    config.public.IS_DEVELOPMENT ||
    !config.public.ADVERTISER_USER_TRACKER_APP_INSIGHTS_KEY ||
    !config.public.ADVERTISER_USER_TRACKER_APP_INSIGHTS_APP_ID
  ) {
    return;
  }

  const script = document.createElement("script");
  script.src = "/assets/tracker.min.js";
  script.async = true;

  script.setAttribute("data-eaut-auto-init", "true");
  script.setAttribute("data-debug", "false");
  script.setAttribute(
    "data-app-insights-key",
    config.public.ADVERTISER_USER_TRACKER_APP_INSIGHTS_KEY,
  );
  script.setAttribute(
    "data-app-insights-app-id",
    config.public.ADVERTISER_USER_TRACKER_APP_INSIGHTS_APP_ID,
  );

  document.head.appendChild(script);
});
